import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FlowBuilder from '../components/FlowBuilder';

export default function WorkflowBuilder() {
  const [workflowName, setWorkflowName] = useState('New Workflow');
  const [workflowDescription, setWorkflowDescription] = useState('');
  const [showBuilder, setShowBuilder] = useState(false);
  const navigate = useNavigate();

  const handleSaveWorkflow = () => {
    alert(`Workflow "${workflowName}" saved successfully!`);
    setShowBuilder(false);
  };

  return (
    <div className="flex-1">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Workflow Builder</h2>
          <p className="text-gray-600">Create workflows visually using drag-and-drop nodes</p>
        </div>

        {!showBuilder ? (
          <div className="space-y-6">
            {/* Workflow Setup */}
            <div className="card p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Create New Workflow</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Workflow Name</label>
                  <input
                    type="text"
                    value={workflowName}
                    onChange={(e) => setWorkflowName(e.target.value)}
                    placeholder="e.g., Supplier Invoice Processing"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                  <textarea
                    value={workflowDescription}
                    onChange={(e) => setWorkflowDescription(e.target.value)}
                    placeholder="Describe what this workflow does..."
                    rows="3"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowBuilder(true)}
                    className="btn btn-primary"
                  >
                    Open Visual Builder →
                  </button>
                  <button
                    onClick={() => navigate('/')}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            {/* Template Suggestions */}
            <div className="card p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Or Start from Template</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { name: 'Supplier Invoice Processing', desc: 'Extract, validate, and post invoices' },
                  { name: 'Purchase Order Approval', desc: 'Multi-tier PO routing and approval' },
                  { name: 'Shopify Order Sync', desc: 'Sync orders from Shopify to Epicor' },
                  { name: 'Email Notification', desc: 'Send custom notifications via email' },
                ].map((template) => (
                  <button
                    key={template.name}
                    onClick={() => {
                      setWorkflowName(template.name);
                      setShowBuilder(true);
                    }}
                    className="text-left p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors"
                  >
                    <p className="font-semibold text-gray-900">{template.name}</p>
                    <p className="text-sm text-gray-600 mt-1">{template.desc}</p>
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="card p-6">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-900">{workflowName}</h3>
              <p className="text-sm text-gray-600">{workflowDescription || 'No description'}</p>
            </div>

            <FlowBuilder onSave={handleSaveWorkflow} />
          </div>
        )}
      </div>
    </div>
  );
}
